import { Endpoints } from '@/api/ApiEndpoints';
import { format, formatDate } from '@/core/helpers/DatetimeConverter';

const Users = {
	Plural: 'Users',
	Single: 'User',
	ModalForm: true,
	DefaultSorting: 'LastName',
	DefaultSortingType: 'asc',
	PrimaryKey: 'id',
	ClientPagination: true,
	ClientPageSize: 10,
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			type: 'text',
		},

		{
			name: 'nickName',
			dbName: 'NickName',
			sortable: true,
			label: 'NickName',
			type: 'text',
		},
		{
			name: 'email',
			dbName: 'Email',
			sortable: true,
			label: 'Email',
			type: 'email',
			format: (item) => {
				return '<a :href="mailto:' + item.email + '">' + item.email + '</a>';
			}
		},
		{
			name: 'country',
			label: 'Country',
			required: true,
			type: 'array',
			objectAttr: {
				name: 'name',
				linkedAttr: 'id',
				link: '/Country/',
			},
			format: (item) => {
				let htmlToReturn = '';
				if (item.country != null) {
					htmlToReturn += '<div>' + item.country.name + '</div>'
				}
				return htmlToReturn;
			}
		},
		{
			name: 'coinsBalance',
			label: 'Coins',
			required: true,
			type: 'array',
			objectAttr: {
				name: 'currentBalance',

			},
			format: (item) => {
				let htmlToReturn = '';
				htmlToReturn += '<div>' +
					item.coinsBalance.currentBalance.toLocaleString() + '</div>'

				return htmlToReturn;
			}
		},
		{
			name: 'createdAt',
			dbName: 'createdAt',
			sortable: true,
			label: 'CreatedAt',
			type: 'date',
			format: (item) => {
				return formatDate(item.createdAt);
			}
		},

	],
	Filters: [
		{
			name: 'Country',
			label: 'Country',
			nameToRequest: 'CountryId',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			type: 'groupedSelect',
			attributes: {
				name: 'name',
				linkedAttr: 'id',
			},
			mapping: (countriesFromResponse) => {
				return countriesFromResponse;
			},
		},
	],
	RowButtons: [
		{
			name: 'details',
			label: 'Details',
			type: 'button',
			iconOnly: true,
			fontIcon: "bi bi-eye",
			onClick: 'openUserDetails',
			api: {
				method: "GET",
				endpoint: (row) => `${Endpoints.USERS}/${row.id}`,
			},
			modal: {
				title: 'User Details',
				fields: [
					{ label: 'ID', key: 'id' },
					{ label: 'Nick Name', key: 'nickName' },
					{ label: 'Avatar', key: 'avatar' },
					{ label: 'Winning Rate', key: 'winningRate' },
					{ label: 'Register', key: 'register' },
					{ label: 'Total Slips', key: 'totalSlips' },
					{ label: 'Won Slips', key: 'wonSlips' },
					{ label: 'Lost Slips', key: 'lostSlips' },
					{ label: 'Open Slips', key: 'openSlips' },
					{ label: 'Points', key: 'points' },
					{ label: 'Rank', key: 'rank' },
					{ label: 'Followers', key: 'followers' },
					{ label: 'Followed By User', key: 'followedByUser' },
				],
			},
		},
		{
			name: 'activity',
			label: 'Activity',
			type: 'link',
			iconOnly: true,
			fontIcon: "bi bi-activity",
			to: (row) => `/users/activity/${row.id}`,
		},
	],
	Actions: {
		addLink: '/Users/Add/',
		editLink: '/users/edit/',
	},
};

export default Users;
 